import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="case_studies" />;

export const Route = createFileRoute("/zh-cn/case-studies/$slug")({
  loader: ({ params }) => loadContentMeta("case_studies", params.slug, "zh-cn"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/zh-cn/case-studies/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

